let _isMobile = {
	ran: false,
	any: false,
	os: {
		version: false,
		platform: {
			android: false,
			blackberry: false,
			ios: false,
			webos: false,
			opera: false,
			windows: false
		}
	},
	browser: {
		engine: false,
		version: false
	}
};

// Detects if we have a mobile device, OS, version and browser used
function _detectMobile() {
	let s, b;
	_isMobile.ran = true;

	// let's detect system and version
	if( s = navigator.userAgent.match( /(Windows.*Phone)[\s\/]*((?:\d+\.?)+)?/i ) ) {
		_isMobile.os.platform.windows = true;
		_isMobile.os.version = typeof s[ 2 ] !== 'undefined' ? s[ 2 ] : false;
		_isMobile.any = true;

	} else if( s = navigator.userAgent.match( /(Android)\s*((?:\d+\.?)+)?/i ) ) {
		_isMobile.os.platform.android = true;
		_isMobile.os.version = typeof s[ 2 ] !== 'undefined' ? s[ 2 ] : false;
		_isMobile.any = true;

	} else if( s = navigator.userAgent.match( /(iPad|iPhone|iPod)(?:;.*CPU.*OS ((?:\d+_?)+))?/i ) ) {
		_isMobile.os.platform.ios = s[ 1 ];
		_isMobile.os.version = typeof s[ 2 ] !== 'undefined' ? s[ 2 ].replace( /_/, '.' ) : false;
		_isMobile.any = true;

	} else if( s = navigator.userAgent.match( /(BlackBerry)\s*(\d+)?/i ) ) {
		_isMobile.os.platform.blackberry = true;
		_isMobile.os.version = typeof s[ 2 ] !== 'undefined' ? s[ 2 ] : false;
		_isMobile.any = true;

	} else if( s = navigator.userAgent.match( /(webOS)[\s\/]*((?:\d+\.?)+)?/i ) ) {
		_isMobile.os.platform.webos = true;
		_isMobile.os.version = typeof s[ 2 ] !== 'undefined' ? s[ 2 ] : false;
		_isMobile.any = true;

	} else if( s = navigator.userAgent.match( /(Opera Mini)[\s\/]*((?:\d+\.?)+)?/i ) ) {
		_isMobile.os.platform.opera = true;
		_isMobile.os.version = typeof s[ 2 ] !== 'undefined' ? s[ 2 ] : false;
		_isMobile.any = true;
	}

	// let's check some browser basics...
	if( b = navigator.userAgent.match( /(OPR)[\s\/]*((?:\d+\.?)+)/i ) ) {
		_isMobile.browser = {
			engine: typeof b[ 1 ] !== 'undefined' ? 'Opera' : false,
			version: typeof b[ 2 ] !== 'undefined' ? b[ 2 ] : false
		};

	} else if( b = navigator.userAgent.match( /(Edge)[\s\/]*((?:\d+\.?)+)/i ) ) {
		_isMobile.browser = {
			engine: typeof b[ 1 ] !== 'undefined' ? 'Edge' : false,
			version: typeof b[ 2 ] !== 'undefined' ? b[ 2 ] : false
		};

	} else if( b = navigator.userAgent.match( /(Firefox|FxiOS)[\s\/]*((?:\d+\.?)+)/i ) ) {
		_isMobile.browser = {
			engine: typeof b[ 1 ] !== 'undefined' ? 'Firefox' : false,
			version: typeof b[ 2 ] !== 'undefined' ? b[ 2 ] : false
		};

	} else if( b = navigator.userAgent.match( /(Chrome|CriOS)[\s\/]*((?:\d+\.?)+)/i ) ) {
		_isMobile.browser = {
			engine: typeof b[ 1 ] !== 'undefined' ? 'Chrome' : false,
			version: typeof b[ 2 ] !== 'undefined' ? b[ 2 ] : false
		};

	} else if( b = navigator.userAgent.match( /(Safari)[\s\/]*((?:\d+\.?)+)/i ) ) {
		_isMobile.browser = {
			engine: typeof b[ 1 ] !== 'undefined' ? 'Safari' : false,
			version: typeof b[ 2 ] !== 'undefined' ? b[ 2 ] : false
		};

	} else if( b = navigator.userAgent.match( /(IEMobile|MSIEMobile)[\s\/]*((?:\d+\.?)+)/i ) ) {
		_isMobile.browser = {
			engine: typeof b[ 1 ] !== 'undefined' ? 'MSIE' : false,
			version: typeof b[ 2 ] !== 'undefined' ? b[ 2 ] : false
		};

	}
}

export function deviceType() {
	if( _isMobile.ran !== true ) {
		_detectMobile();
	}
	return _isMobile;
}

export function devicePlatform() {
	if( _isMobile.ran !== true ) {
		_detectMobile();
	}

	if( _isMobile.any ) {
		return Object.keys( _isMobile.os.platform ).find( ( platform ) => {
			return _isMobile.os.platform[ platform ] !== false;
		} );
	}
}


// WEBPACK FOOTER //
// ./src/utils/deviceType.js